module.exports = __webpack_public_path__ + "media/re-digitando.7eeb8148.mp4";